<template>
  <PopoverRoot v-if="isTouchPointer" v-bind="forwarded">
    <slot />
  </PopoverRoot>
  <TooltipRoot v-else v-bind="forwarded">
    <slot />
  </TooltipRoot>
</template>

<script setup lang="ts">
import { PopoverRoot, TooltipRoot, type TooltipRootEmits, type TooltipRootProps, useForwardPropsEmits } from "reka-ui"
import { useMediaQuery } from "@vueuse/core"

const props = withDefaults(defineProps<TooltipRootProps>(), {
  delayDuration: 200,
  skipDelayDuration: 0
})
const emits = defineEmits<TooltipRootEmits>()

const forwarded = useForwardPropsEmits(props, emits)

const isTouchPointer = useMediaQuery("(hover: none) and (pointer: coarse)")
</script>
